import { ACTIONS, EVENTS } from 'react-joyride';
import { CustomStep } from './Tutorial';

export const taskSteps = (): CustomStep[] => {
  const steps: CustomStep[] = [
    {
      content:
        'Add information on your tasks, assign yourself or others on your team, set due dates and start dates and attach any files you need',
      styles: {
        tooltip: {
          maxWidth: '100%',
        },
        tooltipContainer: {
          maxWidth: '100%',
        },
      },
      target: '#tab-drawer-tab-0',
      disableBeacon: true,
      placement: 'left',
      [ACTIONS.NEXT]: {
        [EVENTS.TARGET_NOT_FOUND]: 'openTaskDrawer',
      },
      [ACTIONS.PREV]: {
        [EVENTS.STEP_AFTER]: 'closeTaskDrawer',
      },
    },
    {
      content: 'Post comments on a task to communicate with your team',
      target: '#tab-drawer-tab-1',
      disableBeacon: true,
      placement: 'left',
      [ACTIONS.NEXT]: {
        [EVENTS.STEP_AFTER]: 'closeTaskDrawer',
      },
      [ACTIONS.PREV]: {
        [EVENTS.TARGET_NOT_FOUND]: 'openTaskDrawer',
      },
    },
  ];
  return steps;
};
